import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
export const ReportRow = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 8px;

  &:hover {
    background: #f4f6f9;
  }
`;
// Covers the whole row, so the row opens it without nesting other links
// inside this one.
export const ReportRowLink = styled(Link) `
  color: inherit;
  text-decoration: none;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
  }

  /* Overrides the global a:focus underline, which a mouse click also triggers. */
  &:focus:not(:focus-visible) {
    text-decoration: none !important;
  }
`;
// Above the row link's overlay, so it stays clickable.
export const ReportRowSecondaryLink = styled(Link) `
  position: relative;
  color: ${THEME.COLOR_GREY};
  text-decoration: none;

  &:hover {
    color: ${THEME.COLOR_ACCENT};
    text-decoration: underline;
  }

  /* Overrides the global a:focus underline, which a mouse click also triggers. */
  &:focus:not(:focus-visible) {
    text-decoration: none !important;
  }
`;
export const ReportRowBody = styled.div `
  flex: 1 1 auto;
  min-width: 0;
`;
export const ReportRowTitle = styled.div `
  overflow: hidden;
  font-size: 0.85em;
  font-weight: 700;
  color: ${THEME.COLOR_PRIMARY};
  text-overflow: ellipsis;
  white-space: nowrap;
`;
// Two lines are enough to tell rows apart; the case shows the rest.
export const ReportRowText = styled.div `
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-top: 2px;
  font-size: 0.85em;
  color: color-mix(in srgb, ${THEME.COLOR_PRIMARY} 80%, white);
`;
export const ReportRowMeta = styled.div `
  margin-top: 4px;
  font-size: 0.75em;
  color: ${THEME.COLOR_GREY};
`;
export const ReportRowAside = styled.div `
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;
//# sourceMappingURL=ReportList.js.map